import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';

const ITEMS = [
  { q: 'Is AlveeTrade really free?', a: 'Yes. The Telegram channel with signals, mentorship and community is 100% free. No hidden charges.' },
  { q: 'Do I need trading experience?', a: 'No. We cover everything from beginner basics to advanced strategies. Follow the roadmap inside.' },
  { q: 'What markets do you cover?', a: 'Primarily Forex (majors + gold), with occasional crypto breakdowns on BTC/ETH when there is a clean setup.' },
  { q: 'Is this financial advice?', a: 'No. All content is educational. You are responsible for your own trades and risk management.' },
  { q: 'Why different languages?', a: 'We run Bangla, Hindi, and English videos so traders can learn fastest in their native tongue.' },
  { q: 'How do I join?', a: 'Click any “Join Telegram” button on this page. You’ll be inside in one tap.' },
];

export default function Faq() {
  return (
    <section id="faq" className="section-pad bg-[hsl(240_6%_7%)] border-t border-b border-border">
      <div className="container-x">
        <div className="mb-8">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-2">Questions · Answered</div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl leading-none">No Fluff. Just Facts.</h2>
        </div>
        <Accordion type="single" collapsible className="max-w-3xl">
          {ITEMS.map((it, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-border" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left hover:text-[hsl(43_92%_56%)] transition-colors">
                <span className="font-semibold">{it.q}</span>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{it.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
